// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1odGs","colCheckbox":"styles_colCheckbox__35Pmk"};